export class CustomerApprovalView {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.dealerContacts = item.dealerContacts;
      this.engineeringContactId = item.engineeringContactId;
      this.engineeringContactName = item.engineeringContactName;
      this.engineeringTeamLeadId = item.engineeringTeamLeadId;
      this.engineeringTeamLeadName = item.engineeringTeamLeadName;
      this.privateNote = item.privateNote ? item.privateNote : '';
      this.privateDocuments = item.privateDocuments;
      this.documents = item.documents;
      this.relatedId = item.relatedId;
      this.relatedName = item.relatedName;
      this.relatedSecondName = item.relatedSecondName;
      this.subRelatedId = item.subRelatedId;
      this.subRelatedName = item.subRelatedName;
      this.subRelatedSecondName = item.subRelatedSecondName;
      this.status = item.status;
      this.statusDescription = item.statusDescription;
      this.dateCreated = item.dateCreated;
      this.activities = item.activities;
      this.engineeringDueDate = item.engineeringDueDate;
      this.approvalDueDate = item.approvalDueDate;
      this.approvalInstructions = item.approvalInstructions
        ? item.approvalInstructions
        : '';
      return;
    }
    this.id = '';
    this.name = '';
    this.dealerContacts = [];
    this.engineeringContactId = '';
    this.engineeringContactName = '';
    this.engineeringTeamLeadId = '';
    this.engineeringTeamLeadName = '';
    this.privateNote = '';
    this.privateDocuments = [];
    this.documents = [];
    this.relatedId = '';
    this.relatedName = '';
    this.relatedSecondName = '';
    this.subRelatedId = '';
    this.subRelatedName = '';
    this.subRelatedSecondName = '';
    this.status = '';
    this.statusDescription = '';
    this.dateCreated = '';
    this.activities = [];
    this.engineeringDueDate = '';
    this.approvalDueDate = '';
    this.approvalInstructions = '';
  }
}
